import * as React from 'react'

import { Button } from 'antd'
import AntdIcon from '@ant-design/icons'
import {
    AlertOutlined,
    BarsOutlined,
    BugOutlined,
    CalendarOutlined,
    CheckOutlined,
    CheckCircleOutlined,
    CheckSquareOutlined,
    ClockCircleOutlined,
    CloseOutlined,
    DeleteOutlined,
    DeleteFilled,
    DisconnectOutlined,
    DislikeFilled,
    DislikeOutlined,
    DownCircleOutlined,
    DownOutlined,
    EditOutlined,
    EllipsisOutlined,
    EnterOutlined,
    ExclamationCircleOutlined,
    EyeInvisibleOutlined,
    EyeOutlined,
    FilterOutlined,
    FolderOpenOutlined,
    FolderOutlined,
    FormOutlined,
    HistoryOutlined,
    HomeOutlined,
    InfoCircleOutlined,
    LeftOutlined,
    LeftCircleOutlined,
    LikeFilled,
    LikeOutlined,
    LinkOutlined,
    LockOutlined,
    MailOutlined,
    MenuOutlined,
    MessageOutlined,
    MinusSquareTwoTone,
    MoreOutlined,
    NotificationOutlined,
    PaperClipOutlined,
    PlusCircleOutlined,
    PlusOutlined,
    PlusSquareTwoTone,
    QuestionCircleOutlined,
    QuestionOutlined,
    RightCircleOutlined,
    RightOutlined,
    SearchOutlined,
    SettingOutlined,
    ShareAltOutlined,
    StarFilled,
    StarOutlined,
    StopOutlined,
    TagOutlined,
    TagsOutlined,
    TeamOutlined,
    ToTopOutlined,
    UpCircleOutlined,
    UploadOutlined,
    UpOutlined,
    UserAddOutlined,
    UserDeleteOutlined,
    UsergroupAddOutlined,
    UsergroupDeleteOutlined,
    UserOutlined,
    WarningOutlined,
    WechatOutlined
} from '@ant-design/icons'
import { ButtonType } from 'antd/lib/button'
import {
    CustomIconComponentProps,
    IconBaseProps
} from '@ant-design/icons/lib/components/Icon'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import { ButtonShape } from 'antd/lib/button'

import * as styles from './Icons.module.less'

export interface SvgIconBaseProps extends IconBaseProps {
    fill?: string
    height?: string
    svg?: any
    viewBox?: string
    width?: string
}

const GenericIcon: React.FC<SvgIconBaseProps> = (props) => {
    const { fill, height, ref, viewBox, width, svg, ...iconBaseProps } = props
    const svgComponent: React.ComponentType<CustomIconComponentProps> = () => (
        <svg
            fill={fill || 'currentColor'}
            height={height || '1em'}
            viewBox={viewBox || '0 0 1024 1024'}
            width={width || '1em'}
        >
            {svg}
        </svg>
    )
    // @ts-ignore
    return <AntdIcon component={svgComponent} {...iconBaseProps} />
}

interface ButtonIconBaseProps {
    onClick?: () => void
    className?: string
    style?: React.CSSProperties
    type?: ButtonType
}

interface ButtonWrapperProps extends ButtonIconBaseProps {
    type?: ButtonType
    onButtonClick?: () => void
    className?: string
    style?: React.CSSProperties
    svg: React.SVGProps<SVGSVGElement>
}

const ButtonWrapper: React.FC<ButtonWrapperProps> = (props) => {
    return (
        <div className={`${props.className} ${styles.button}`}>
            <Button
                shape="circle"
                onClick={props.onButtonClick}
                type={props.type}
                style={props.style}
            >
                <AntdIcon
                    component={() => (
                        <svg
                            width="1.6em"
                            height="1.6em"
                            fill="currentColor"
                            viewBox="0 0 1024 1024"
                        >
                            {props.svg}
                        </svg>
                    )}
                    style={props.style}
                />
            </Button>
        </div>
    )
}

// export const Move: React.FC<IconBaseProps> = props => (
//   <SvgIcon
//     svg={
//       <path d="M512 0q18.005333 0 30.336 12.330667l150.656 150.997333q12.672 12.672 12.672 30.336t-12.501333 30.165333-30.165333 12.501333-30.336-12.672l-77.994667-77.994667 0 323.669333 323.669333 0-77.994667-77.994667q-12.672-12.672-12.672-30.336t12.501333-30.165333 30.165333-12.501333 30.336 12.672l150.997333 150.656q12.330667 12.330667 12.330667 30.336t-12.330667 29.994667l-150.997333 150.997333q-12.672 12.672-30.336 12.672t-30.165333-12.501333-12.501333-30.165333 12.672-30.336l77.994667-77.994667-323.669333 0 0 323.669333 77.994667-77.994667q12.672-12.672 30.336-12.672t30.165333 12.501333 12.501333 30.165333-12.672 30.336l-150.656 150.997333q-12.330667 12.330667-30.336 12.330667-17.664 0-29.994667-12.330667l-150.997333-150.997333q-12.672-12.672-12.672-30.336t12.501333-30.165333 30.165333-12.501333 30.336 12.672l77.994667 77.994667 0-323.669333-323.669333 0 77.994667 77.994667q12.672 12.672 12.672 30.336t-12.501333 30.165333-30.165333 12.501333-30.336-12.672l-150.997333-150.656q-12.330667-12.330667-12.330667-30.336t12.330667-30.336l150.997333-150.656q12.672-12.672 30.336-12.672t30.165333 12.501333 12.501333 30.165333-12.672 30.336l-77.994667 77.994667 323.669333 0 0-323.669333-77.994667 77.994667q-12.672 12.672-30.336 12.672t-30.165333-12.501333-12.501333-30.165333 12.672-30.336l150.656-150.997333q12.330667-12.330667 30.336-12.330667z" />
//     }
//     {...props}
//   />
// )

export const Add: React.FC<ButtonIconBaseProps> = (props) => {
    return (
        <ButtonWrapper
            onButtonClick={props.onClick}
            svg={
                <svg>
                    <path
                        d="M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z"
                        fill="currentColor"
                    />
                    <path
                        d="M448 298.666667h128v426.666666h-128z"
                        fill="#FFFFFF"
                    />
                    <path
                        d="M298.666667 448h426.666666v128H298.666667z"
                        fill="#FFFFFF"
                    />
                </svg>
            }
            {...props}
        />
    )
}

export const AddNodeChild: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M928 640h-256c-17.066667 0-32 14.933333-32 32V768H288V416h128c17.066667 0 32-14.933333 32-32V128c0-17.066667-14.933333-32-32-32h-320C78.933333 96 64 110.933333 64 128v256c0 17.066667 14.933333 32 32 32h128v384c0 17.066667 14.933333 32 32 32h384v96c0 17.066667 14.933333 32 32 32h256c17.066667 0 32-14.933333 32-32v-256c0-17.066667-14.933333-32-32-32zM128 160h256v192H128v-192z M608 320h128v128c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-128h128c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32h-128V128c0-17.066667-14.933333-32-32-32s-32 14.933333-32 32v128h-128c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32z" />
        }
        {...props}
    />
)

export const AddNodeSibling: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M384 704c17.066667 0 32-14.933333 32-32v-128h128c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32h-128v-128c0-17.066667-14.933333-32-32-32s-32 14.933333-32 32v128h-128c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h128v128c0 17.066667 14.933333 32 32 32z" />
        }
        {...props}
    />
)

export const AddUserIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UserAddOutlined {...iconProps} />
}
export const AddTeamIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UsergroupAddOutlined {...iconProps} />
}
export const AlertIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <AlertOutlined {...iconProps} />
}
export const AttachmentIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <PaperClipOutlined {...iconProps} />
}
export const BlockedIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <StopOutlined {...iconProps} />
}
export const BugIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <BugOutlined {...iconProps} />
}
export const CalendarIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <CalendarOutlined {...iconProps} />
}
export const CloseIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <CloseOutlined {...iconProps} />
}
export const CheckSquareIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <CheckSquareOutlined {...iconProps} />
}
export const ConversationIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <WechatOutlined {...iconProps} />
}
export const DeleteFilledIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DeleteFilled {...iconProps} />
}
export const DeleteOutlinedIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DeleteOutlined {...iconProps} />
}
export const DislikeFilledIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DislikeFilled {...iconProps} />
}
export const DislikeIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DislikeOutlined {...iconProps} />
}
export const DoneIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <CheckOutlined {...iconProps} />
}
export const DownCircleIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DownCircleOutlined {...iconProps} />
}
export const DownIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DownOutlined {...iconProps} />
}
export const EnterIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <EnterOutlined {...iconProps} />
}
export const EditIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <EditOutlined {...iconProps} />
}
export const FavoriteFilledIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <StarFilled {...iconProps} />
}
export const FavoriteIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <StarOutlined {...iconProps} />
}
export const FilterIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <FilterOutlined {...iconProps} />
}
export const FolderIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <FolderOutlined {...iconProps} />
}
export const FolderOpenIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <FolderOpenOutlined {...iconProps} />
}
export const FollowIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <EyeOutlined {...iconProps} />
}
export const FormIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <FormOutlined {...iconProps} />
}
export const HelpIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <QuestionCircleOutlined {...iconProps} />
}
export const HistoryIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <HistoryOutlined {...iconProps} />
}
export const HomeIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <HomeOutlined {...iconProps} />
}
export const InfoIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <InfoCircleOutlined {...iconProps} />
}
export const IssueIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <WarningOutlined {...iconProps} />
}
export const LeftCircleIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <LeftCircleOutlined {...iconProps} />
}
export const LeftIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <LeftOutlined {...iconProps} />
}
export const LikeFilledIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <LikeFilled {...iconProps} />
}
export const LikeIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <LikeOutlined {...iconProps} />
}
export const LinkIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <LinkOutlined {...iconProps} />
}
export const LockIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <LockOutlined {...iconProps} />
}
export const MailIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <MailOutlined {...iconProps} />
}
export const MenuIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <MenuOutlined {...iconProps} />
}
export const MessageIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <MessageOutlined {...iconProps} />
}
export const MinusSquareIcon = (props: AntdIconProps) => {
    const { ref, ...iconProps } = props
    return <MinusSquareTwoTone {...iconProps} />
}
export const MoreIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <MoreOutlined {...iconProps} />
}
export const MoreHorizontalIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <EllipsisOutlined {...iconProps} />
}
export const NotificationIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <NotificationOutlined {...iconProps} />
}
export const PlusCircleIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <PlusCircleOutlined {...iconProps} />
}
export const PlusIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <PlusOutlined {...iconProps} />
}
export const PlusSquareIcon = (props: AntdIconProps) => {
    const { ref, ...iconProps } = props
    return <PlusSquareTwoTone {...iconProps} />
}
export const RemoveUserIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UserDeleteOutlined {...iconProps} />
}
export const RemoveTeamIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UsergroupDeleteOutlined {...iconProps} />
}
export const RightCircleIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <RightCircleOutlined {...iconProps} />
}
export const RightIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <RightOutlined {...iconProps} />
}
export const SearchIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <SearchOutlined {...iconProps} />
}
export const SettingsIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <SettingOutlined {...iconProps} />
}
export const ShareIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <ShareAltOutlined {...iconProps} />
}
export const StarIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <StarOutlined {...iconProps} />
}
export const TagIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <TagOutlined {...iconProps} />
}
export const TagsIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <TagsOutlined {...iconProps} />
}
export const TeamIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <TeamOutlined {...iconProps} />
}
export const TimelineIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <ClockCircleOutlined {...iconProps} />
}
export const ToTopIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <ToTopOutlined {...iconProps} />
}
export const UnfollowIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <EyeInvisibleOutlined {...iconProps} />
}
export const UnlinkIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <DisconnectOutlined {...iconProps} />
}
export const UpCircleIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UpCircleOutlined {...iconProps} />
}
export const UpIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UpOutlined {...iconProps} />
}
export const UploadIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UploadOutlined {...iconProps} />
}
export const UserIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <UserOutlined {...iconProps} />
}
export const WarningIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <ExclamationCircleOutlined {...iconProps} />
}
export const WarningCircleIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <ExclamationCircleOutlined {...iconProps} />
}
export const WorkItemIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <CheckCircleOutlined {...iconProps} />
}
export const QuestionIcon = (props: IconBaseProps) => {
    const { ref, ...iconProps } = props
    return <QuestionOutlined {...iconProps} />
}

export const CaretUp: React.FC<ButtonIconBaseProps> = (props) => (
    <ButtonWrapper
        onButtonClick={props.onClick}
        svg={
            <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
        }
        {...props}
    />
)

export const CaretDown: React.FC<ButtonIconBaseProps> = (props) => (
    <ButtonWrapper
        onButtonClick={props.onClick}
        svg={
            <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" />
        }
        {...props}
    />
)

export const CaretLeft: React.FC<ButtonIconBaseProps> = (props) => (
    <ButtonWrapper
        onButtonClick={props.onClick}
        svg={
            <path d="M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" />
        }
        {...props}
    />
)

export const CaretRight: React.FC<ButtonIconBaseProps> = (props) => (
    <ButtonWrapper
        onButtonClick={props.onClick}
        svg={
            <path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" />
        }
        {...props}
    />
)

export const DashboardIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M128 554.666667l341.333333 0 0-426.666667-341.333333 0 0 426.666667zM128 896l341.333333 0 0-256-341.333333 0 0 256zM554.666667 896l341.333333 0 0-426.666667-341.333333 0 0 426.666667zM554.666667 128l0 256 341.333333 0 0-256-341.333333 0z" />
        }
        {...props}
    />
)

export const DescriptionIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="m945.23077,128c0,-15.75385 -13.78462,-29.53846 -29.53846,-29.53846l-807.38462,0c-15.75384,0 -29.53846,13.78461 -29.53846,29.53846l0,59.07692c0,15.75385 13.78462,29.53847 29.53846,29.53847l807.38462,0c15.75384,0 29.53846,-13.78462 29.53846,-29.53847l0,-59.07692zm-0.07691,236.30769c0,-15.75384 -13.40002,-29.53846 -29.15386,-29.53846l-808,0c-16.06153,0 -29.23077,13.78462 -29.23077,29.53846l0,59.07692c0,15.75385 13.78462,29.53847 29.53846,29.53847l807.69231,0c15.29229,0 29,-13.78462 29,-29.53847l0,-59.07692l0,0zm-156.38462,472.61539c0,-15.75385 -13.78462,-29.53847 -29.53846,-29.53847l-649.84616,0c-15.75384,0 -29.53846,13.78462 -29.53846,29.53847l0,59.07692c0,15.75385 13.78462,29.53846 29.53846,29.53846l649.84616,0c15.75384,0 29.53846,-13.78461 29.53846,-29.53846l0,-59.07692zm157.53846,-236.3077c0,-15.75384 -13.78462,-29.53846 -29.53846,-29.53846l-807.38462,0c-15.75384,0 -29.53846,13.78462 -29.53846,29.53846l0,59.07693c0,15.75384 13.78462,29.53846 29.53846,29.53846l807.38462,0c15.75384,0 29.53846,-13.78462 29.53846,-29.53846l0,-59.07693z" />
        }
        {...props}
    />
)

export const OpenIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M170.65984 42.65984l298.65984 0q17.67424 0 30.16704 12.4928t12.4928 30.16704-12.4928 30.16704-30.16704 12.4928l-298.65984 0q-17.67424 0-30.16704 12.4928t-12.4928 30.16704l0 682.65984q0 17.67424 12.4928 30.16704t30.16704 12.4928l682.65984 0q17.67424 0 30.16704-12.4928t12.4928-30.16704l0-298.65984q0-17.67424 12.4928-30.16704t30.16704-12.4928 30.16704 12.4928 12.4928 30.16704l0 298.65984q0 53.00224-37.49888 90.50112t-90.50112 37.49888l-682.65984 0q-53.00224 0-90.50112-37.49888t-37.49888-90.50112l0-682.65984q0-53.00224 37.49888-90.50112t90.50112-37.49888zM682.65984 42.65984l256 0q17.67424 0 30.16704 12.4928t12.4928 30.16704l0 256q0 17.67424-12.4928 30.16704t-30.16704 12.4928-30.16704-12.4928-12.4928-30.16704l0-153.00608-353.9968 353.9968q-12.32896 12.32896-30.0032 12.32896-18.3296 0-30.49472-12.16512t-12.16512-30.49472q0-17.67424 12.32896-30.0032l353.9968-353.9968-153.00608 0q-17.67424 0-30.16704-12.4928t-12.4928-30.16704 12.4928-30.16704 30.16704-12.4928z" />
        }
        {...props}
    />
)

export const DetailsIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M866.461538 78.769231H157.538462C114.215385 78.769231 78.769231 114.215385 78.769231 157.538462v708.923076c0 43.323077 35.446154 78.769231 78.769231 78.769231h708.923076c43.323077 0 78.769231-35.446154 78.769231-78.769231V157.538462c0-43.323077-35.446154-78.769231-78.769231-78.769231zM236.307692 275.692308c0-11.815385 7.876923-19.692308 19.692308-19.692308h196.923077c11.815385 0 19.692308 7.876923 19.692308 19.692308v196.923077c0 11.815385-7.876923 19.692308-19.692308 19.692307H256c-11.815385 0-19.692308-7.876923-19.692308-19.692307V275.692308z m472.615385 512c0 11.815385-7.876923 19.692308-19.692308 19.692307H256c-11.815385 0-19.692308-7.876923-19.692308-19.692307v-39.384616c0-11.815385 7.876923-19.692308 19.692308-19.692307h433.230769c11.815385 0 19.692308 7.876923 19.692308 19.692307v39.384616z m78.769231-157.538462c0 11.815385-7.876923 19.692308-19.692308 19.692308H256c-11.815385 0-19.692308-7.876923-19.692308-19.692308v-39.384615c0-11.815385 7.876923-19.692308 19.692308-19.692308h512c11.815385 0 19.692308 7.876923 19.692308 19.692308v39.384615z m0-157.538461c0 11.815385-7.876923 19.692308-19.692308 19.692307H571.076923c-11.815385 0-19.692308-7.876923-19.692308-19.692307v-39.384616c0-11.815385 7.876923-19.692308 19.692308-19.692307h196.923077c11.815385 0 19.692308 7.876923 19.692308 19.692307v39.384616z m0-157.538462c0 11.815385-7.876923 19.692308-19.692308 19.692308H571.076923c-11.815385 0-19.692308-7.876923-19.692308-19.692308v-39.384615c0-11.815385 7.876923-19.692308 19.692308-19.692308h196.923077c11.815385 0 19.692308 7.876923 19.692308 19.692308v39.384615z" />
        }
        {...props}
    />
)

export const DiscussionIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M896 256l-85.333333 0 0 384-554.666667 0 0 85.333333c0 23.466667 19.2 42.666667 42.666667 42.666667l469.333333 0 170.666667 170.666667 0-640c0-23.466667-19.2-42.666667-42.666667-42.666667zM725.333333 512l0-384c0-23.466667-19.2-42.666667-42.666667-42.666667l-554.666667 0c-23.466667 0-42.666667 19.2-42.666667 42.666667l0 597.333333 170.666667-170.666667 426.666667 0c23.466667 0 42.666667-19.2 42.666667-42.666667z" />
        }
        {...props}
    />
)

export const IncubatorIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M853.333333 469.333333h128v85.333334h-128v-85.333334M42.666667 469.333333h128v85.333334H42.666667v-85.333334M554.666667 42.666667v128h-85.333334V42.666667h85.333334M209.92 149.333333l90.88 91.306667-60.586667 60.16L149.333333 210.346667 209.92 149.333333m513.28 90.88l90.453333-90.88 61.013334 61.013334-90.88 90.453333-60.586667-60.586667M512 256a256 256 0 0 1 256 256c0 94.72-51.626667 177.493333-128 221.866667V810.666667a42.666667 42.666667 0 0 1-42.666667 42.666666h-170.666666a42.666667 42.666667 0 0 1-42.666667-42.666666v-76.8c-76.373333-44.373333-128-127.146667-128-221.866667a256 256 0 0 1 256-256m85.333333 640v42.666667a42.666667 42.666667 0 0 1-42.666666 42.666666h-85.333334a42.666667 42.666667 0 0 1-42.666666-42.666666v-42.666667h170.666666m-128-128h85.333334v-90.88c73.813333-18.773333 128-85.76 128-165.12a170.666667 170.666667 0 0 0-170.666667-170.666667 170.666667 170.666667 0 0 0-170.666667 170.666667c0 79.36 54.186667 146.346667 128 165.12V768z" />
        }
        {...props}
    />
)

export const KanbanIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M902.4 96H121.6a25.6 25.6 0 0 0-25.6 25.6v780.8a25.6 25.6 0 0 0 25.6 25.6h780.8a25.6 25.6 0 0 0 25.6-25.6V121.6a25.6 25.6 0 0 0-25.6-25.6zM467.2 768H192V192h275.2z m364.8-192H556.8V192h275.2z" />
        }
        {...props}
    />
)

export const LoadingIcon: React.FC<IconBaseProps> = (props): JSX.Element => (
    <div style={{ color: 'blue' }}>
        {' '}
        <AntdIcon spin />
    </div>
)

export const MoveIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M548.827429 548.827429v295.460571l68.699428-68.717714a36.571429 36.571429 0 0 1 51.730286 51.730285l-129.298286 129.28a37.229714 37.229714 0 0 1-0.950857 0.914286 36.48 36.48 0 0 1-26.752 11.648c-9.014857 0-17.28-3.254857-23.643429-8.667428a36.827429 36.827429 0 0 1-4.571428-3.876572l-129.28-129.298286a36.571429 36.571429 0 1 1 51.712-51.730285l69.211428 69.211428V548.827429H179.712l68.717714 68.699428a36.571429 36.571429 0 0 1-51.730285 51.730286l-129.28-129.298286a37.229714 37.229714 0 0 1-0.914286-0.950857A36.48 36.48 0 0 1 54.857143 512.256c0-9.014857 3.254857-17.28 8.667428-23.643429 1.152-1.609143 2.450286-3.126857 3.876572-4.571428l129.298286-129.28a36.571429 36.571429 0 1 1 51.730285 51.712L179.2 475.684571h296.466286V179.218286l-69.211429 69.211428a36.571429 36.571429 0 0 1-51.730286-51.730285l129.298286-129.28c1.444571-1.462857 2.962286-2.742857 4.571429-3.894858 6.363429-5.412571 14.628571-8.667429 23.643428-8.667428 10.569143 0 20.077714 4.48 26.752 11.648 0.329143 0.292571 0.64 0.585143 0.950857 0.914286l129.28 129.28a36.571429 36.571429 0 1 1-51.712 51.730285l-68.699428-68.717714v295.972571h295.954286l-69.211429-69.211428a36.571429 36.571429 0 0 1 51.730286-51.730286l129.28 129.298286c1.462857 1.444571 2.742857 2.962286 3.894857 4.571428 5.412571 6.363429 8.667429 14.628571 8.667428 23.643429 0 10.569143-4.48 20.077714-11.648 26.752a37.229714 37.229714 0 0 1-0.914285 0.950857l-129.28 129.28a36.571429 36.571429 0 1 1-51.730286-51.712l68.717714-68.699428H548.827429z" />
        }
        {...props}
    />
)

export const OrganizationIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M235.2 896c-16 0-30.4-1.6-46.4-6.4-44.8-11.2-83.2-41.6-105.6-81.6-48-84.8-19.2-192 64-240 40-24 88-30.4 132.8-17.6 44.8 12.8 83.2 41.6 107.2 81.6s30.4 88 17.6 132.8-41.6 83.2-81.6 107.2c-27.2 16-57.6 24-88 24z m0-288c-19.2 0-38.4 4.8-56 14.4-52.8 30.4-72 99.2-41.6 153.6 14.4 25.6 38.4 44.8 68.8 52.8 28.8 8 59.2 3.2 84.8-11.2 25.6-14.4 44.8-38.4 52.8-67.2s3.2-59.2-11.2-84.8-38.4-44.8-68.8-52.8c-9.6-3.2-19.2-4.8-28.8-4.8zM788.8 896c-30.4 0-60.8-8-88-24-40-24-70.4-60.8-81.6-107.2s-6.4-92.8 17.6-132.8c24-40 60.8-70.4 107.2-81.6 44.8-12.8 92.8-6.4 132.8 17.6 84.8 48 113.6 156.8 64 240-24 40-60.8 70.4-107.2 81.6-14.4 4.8-28.8 6.4-44.8 6.4z m0-288c-9.6 0-19.2 1.6-28.8 3.2-28.8 8-52.8 25.6-67.2 52.8-14.4 25.6-19.2 56-11.2 84.8 8 28.8 25.6 52.8 52.8 67.2 25.6 14.4 56 19.2 84.8 11.2 28.8-8 52.8-25.6 67.2-52.8 30.4-52.8 12.8-121.6-41.6-153.6-17.6-8-36.8-12.8-56-12.8zM512 416c-97.6 0-176-78.4-176-176S414.4 64 512 64s176 78.4 176 176-78.4 176-176 176z m0-288c-62.4 0-112 49.6-112 112s49.6 112 112 112 112-49.6 112-112-49.6-112-112-112zM830.4 614.4h-1.6c-17.6-1.6-30.4-16-30.4-33.6v-3.2c0-6.4 1.6-11.2 1.6-17.6 0-110.4-62.4-209.6-161.6-259.2-16-8-22.4-27.2-14.4-43.2 8-16 27.2-22.4 43.2-14.4C788.8 304 864 424 864 560c0 8 0 14.4-1.6 22.4v3.2c0 16-14.4 28.8-32 28.8zM512 912c-70.4 0-139.2-20.8-196.8-60.8-14.4-9.6-19.2-30.4-8-44.8 9.6-14.4 30.4-19.2 44.8-8 48 32 104 49.6 161.6 49.6 57.6 0 113.6-17.6 161.6-49.6 14.4-9.6 35.2-6.4 44.8 8 9.6 14.4 6.4 35.2-8 44.8C651.2 891.2 582.4 912 512 912zM193.6 614.4c-16 0-30.4-12.8-32-30.4v-3.2c0-6.4-1.6-14.4-1.6-20.8 0-136 75.2-256 198.4-316.8 16-8 35.2-1.6 43.2 14.4s1.6 35.2-14.4 43.2C286.4 350.4 224 449.6 224 560c0 6.4 0 11.2 1.6 16v3.2c1.6 17.6-12.8 33.6-30.4 33.6 0 1.6-1.6 1.6-1.6 1.6z" />
        }
        {...props}
    />
)

export const ProjectIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M858.112 61.44h-88.064c-12.288-34.816-47.104-61.44-86.016-61.44H342.016c-40.96 0-73.728 26.624-86.016 61.44H165.888C118.784 61.44 81.92 102.4 81.92 153.6v778.24C81.92 983.04 118.784 1024 165.888 1024h692.224c47.104 0 83.968-40.96 83.968-92.16v-778.24C942.08 102.4 905.216 61.44 858.112 61.44zM331.776 92.16c0-6.144 4.096-10.24 10.24-10.24h342.016c6.144 0 10.24 4.096 10.24 10.24v28.672c0 6.144-4.096 10.24-10.24 10.24H342.016c-6.144 0-10.24-4.096-10.24-10.24V92.16z m528.384 839.68c0 6.144-2.048 8.192-4.096 10.24H167.936c-2.048-2.048-4.096-6.144-4.096-10.24v-778.24c0-4.096 2.048-8.192 4.096-10.24h83.968c10.24 38.912 47.104 69.632 90.112 69.632h342.016c43.008 0 79.872-30.72 90.112-69.632h83.968c0 2.048 2.048 6.144 2.048 10.24v778.24z m-141.312-192.512H305.152c-22.528 0-40.96 18.432-40.96 40.96s18.432 40.96 40.96 40.96H716.8c22.528 0 40.96-18.432 40.96-40.96s-16.384-40.96-38.912-40.96z m0-204.8H305.152c-22.528 0-40.96 18.432-40.96 40.96s18.432 40.96 40.96 40.96H716.8c22.528 0 40.96-18.432 40.96-40.96s-16.384-40.96-38.912-40.96z m0-225.28H305.152c-22.528 0-40.96 18.432-40.96 40.96s18.432 40.96 40.96 40.96H716.8c22.528 0 40.96-18.432 40.96-40.96 2.048-22.528-16.384-40.96-38.912-40.96z" />
        }
        {...props}
    />
)

export const ProjectGanttIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M0 0l0 896 128 0 0-896-128 0zm896 0l0 896 128 0 0-896-128 0zm-640 128l0 128 256 0 0-128-256 0zm128 256l0 128 256 0 0-128-256 0zm128 256l0 128 256 0 0-128-256 0z" />
        }
        {...props}
    />
)

export const PortfolioIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M880.448 256 704 256l0-79.915C704 149.57 682.84 128 656.325 128L368.167 128C341.652 128 320 149.57 320 176.085L320 256 144.044 256C100.02 256 64 292.148 64 336.173L64 526l0 64 0 226.437C64 860.461 100.02 896 144.044 896l736.404 0C924.473 896 960 860.461 960 816.437L960 590l0-64L960 336.173C960 292.148 924.473 256 880.448 256zM896 816.437c0 8.696-6.855 15.563-15.552 15.563L144.044 832c-8.697 0-16.044-6.867-16.044-15.563L128 590l208 0 0 16.044C336 658.988 379.258 702 432.202 702L592.29 702c52.944 0 95.71-43.012 95.71-95.956L688 590l208 0L896 816.437zM400 590l224 0 0 16.044c0 17.51-14.2 31.956-31.71 31.956L432.202 638C414.692 638 400 623.554 400 606.044L400 590zM624.308 526 400.185 526 128 526 128 336.173c0-8.697 7.347-16.173 16.044-16.173l176.097 0L384 320l0-63.871L384 192l256 0 0 64.129L640 320l64.352 0 176.097 0c8.696 0 15.552 7.476 15.552 16.173L896.001 526 624.308 526zM384 256l256 0 0 64-256 0 0-64Z" />
        }
        {...props}
    />
)

export const RemoveIcon: React.FC<ButtonIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M809.984 169.984l0 86.016-596.010667 0 0-86.016 148.010667 0 43.989333-41.984 212.010667 0 43.989333 41.984 148.010667 0zM256 809.984l0-512 512 0 0 512q0 34.005333-25.984 59.989333t-59.989333 25.984l-340.010667 0q-34.005333 0-59.989333-25.984t-25.984-59.989333z" />
        }
        {...props}
    />
)

export const Remove: React.FC<ButtonIconBaseProps> = (props) => (
    <ButtonWrapper
        onButtonClick={props.onClick}
        style={{ color: 'red' }}
        // type='danger'
        // className2={styles.iconDelete}
        svg={
            <path d="M809.984 169.984l0 86.016-596.010667 0 0-86.016 148.010667 0 43.989333-41.984 212.010667 0 43.989333 41.984 148.010667 0zM256 809.984l0-512 512 0 0 512q0 34.005333-25.984 59.989333t-59.989333 25.984l-340.010667 0q-34.005333 0-59.989333-25.984t-25.984-59.989333z" />
        }
        {...props}
    />
)

export const RiskIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M0 6400 l0 -6400 110 0 c69 0 243 17 472 45 542 67 1167 143 1998 245 410 50 755 93 768 95 l22 5 -2 2404 c-2 1322 -1 2403 2 2401 3 -2 756 -1171 1675 -2599 l1670 -2596 72 0 c64 0 112 12 405 104 183 57 495 154 693 216 198 61 473 147 610 190 138 43 405 127 595 185 190 59 485 151 655 204 l310 97 3 108 3 107 -1557 2207 c-857 1214 -1571 2224 -1587 2245 -16 21 -28 39 -26 41 2 1 44 26 92 55 462 277 916 752 1217 1275 460 799 596 1617 434 2609 -156 962 -625 1724 -1399 2276 -611 436 -1432 721 -2382 827 -441 49 -370 47 -2680 51 l-2173 4 0 -6401z m3865 3399 c472 -55 925 -325 1146 -683 128 -209 189 -468 176 -751 -21 -437 -171 -793 -465 -1106 -241 -256 -532 -403 -867 -439 -101 -10 -126 -9 -299 14 -103 14 -189 26 -190 26 0 0 0 660 1 1467 l3 1468 122 11 c134 11 233 9 373 -7z" />
        }
        // height='1em'
        // width='.8em'
        // viewBox='0 0 512 512'
        {...props}
    />
)

export const TaskIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M918.019413 1020.586667H105.86112c-49.52064 0-89.82528-39.594667-89.82528-88.152747V135.703893c0.119467-48.564907 40.185173-88.03328 89.82528-88.03328h148.31616C269.847893 21.357227 298.431147 3.413333 331.564373 3.413333h360.987307c33.1264 0 61.719893 17.943893 77.387093 44.25728h147.59936c49.759573-0.119467 90.187093 39.348907 90.426027 88.03328v796.730027c-0.23552 48.68096-40.424107 88.03328-89.944747 88.152747z m-225.826133-928.3072l-360.864427-0.477867 0.119467 0.477867v87.555413l360.864427 0.484693-0.119467-88.040106z m225.467733 43.424426l-135.28064 0.354987v43.776c0.119467 48.919893-40.065707 88.630613-89.94816 88.869547H331.44832c-49.636693 0-89.951573-39.949653-89.951573-88.869547V136.05888H105.857707l0.3584 796.37504 811.803306-0.3584-0.3584-796.371627zM361.472 552.5504l87.552 96.167253 213.74976-229.297493c16.745813-18.059947 45.325653-19.26144 63.75424-2.75456a43.605333 43.605333 0 0 1 2.8672 62.440107l-247.466667 265.417386a45.974187 45.974187 0 0 1-33.252693 14.35648h-0.3584c-12.796587-0.12288-24.879787-5.505707-33.365333-14.83776l-120.695467-132.529493c-16.626347-18.176-14.9504-46.165333 3.587413-62.43328 18.5344-16.267947 47.121067-14.711467 63.627947 3.47136z" />
        }
        {...props}
    />
)

export const WbsIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M1024 713.152V896q0 22.848-16 38.848t-38.848 16h-182.848q-22.848 0-38.848-16t-16-38.848v-182.848q0-22.848 16-38.848t38.848-16h54.848v-109.728h-292.576v109.728h54.848q22.848 0 38.848 16t16 38.848V896q0 22.848-16 38.848t-38.848 16h-182.848q-22.848 0-38.848-16t-16-38.848v-182.848q0-22.848 16-38.848t38.848-16h54.848v-109.728H182.848v109.728h54.848q22.848 0 38.848 16t16 38.848V896q0 22.848-16 38.848t-38.848 16H54.848q-22.848 0-38.848-16T0 896v-182.848q0-22.848 16-38.848t38.848-16h54.848v-109.728q0-29.728 21.728-51.424t51.424-21.728h292.576v-109.728h-54.848q-22.848 0-38.848-16t-16-38.848V128q0-22.848 16-38.848t38.848-16h182.848q22.848 0 38.848 16t16 38.848v182.848q0 22.848-16 38.848t-38.848 16h-54.848v109.728h292.576q29.728 0 51.424 21.728t21.728 51.424v109.728h54.848q22.848 0 38.848 16t16 38.848z" />
        }
        {...props}
    />
)

export const WbsControlAccountIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path d="M128 128h256v170.666667H128V128m512 298.666667h256v170.666666h-256v-170.666666m0 298.666666h256v170.666667h-256v-170.666667m-85.333333-170.666666H298.666667v213.333333h256v85.333333H213.333333V384h85.333334v85.333333h256v85.333334z" />
        }
        {...props}
    />
)

export const WorkPackageIcon: React.FC<SvgIconBaseProps> = (props) => (
    <GenericIcon
        svg={
            <path
                d="M42.666667 213.333333l469.333333-213.333333 469.333333 213.333333 0 597.333333-469.333333 213.333333-469.333333-213.333333 0-597.333333zM469.333333 454.016l-341.333333-155.008 0 456.661333 341.333333 155.349333 0-457.002667zM896 755.669333l0-456.661333-341.333333 155.008 0 457.002667zM826.666667 236.672l-314.666667-143.018667-314.666667 143.018667 314.666667 143.018667z"
                p-id="9476"
            />
        }
        {...props}
    />
)

export const Icons = {
    Application: {
        Arrows: {
            DownCircleIcon,
            DownIcon,
            LeftCircleIcon,
            LeftIcon,
            MoveIcon,
            RightCircleIcon,
            RightIcon,
            UpCircleIcon,
            UpIcon
        },
        AttachmentIcon,
        CalendarIcon,
        CheckSquareIcon,
        CloseIcon,
        ConversationIcon,
        DashboardIcon,
        DeleteFilledIcon,
        DeleteOutlinedIcon,
        DescriptionIcon,
        DetailsIcon,
        DiscussionIcon,
        DislikeFilledIcon,
        DislikeIcon,
        EditIcon,
        EnterOutlined,
        FavoriteFilledIcon,
        FavoriteIcon,
        FilterIcon,
        FolderOutlined,
        FolderOpenOutlined,
        FollowIcon,
        FormIcon,
        HelpIcon,
        HistoryIcon,
        HomeIcon,
        InfoIcon,
        LikeFilledIcon,
        LikeIcon,
        LinkIcon,
        LoadingIcon,
        LockIcon,
        MenuIcon,
        MinusSquareIcon,
        MoreHorizontalIcon,
        MoreIcon,
        Notifications: {
            AlertIcon,
            InfoIcon,
            ImportantIcon: WarningCircleIcon,
            MailIcon,
            MessageIcon,
            NotificationIcon
        },
        OpenIcon,
        PlusCircleIcon,
        PlusIcon,
        PlusSquareIcon,
        QuestionIcon,
        Remove,
        RemoveIcon,
        SearchIcon,
        SettingsIcon,
        ShareIcon,
        TagIcon,
        TagsIcon,
        TimelineIcon,
        ToTopIcon,
        UnfollowIcon,
        UnlinkIcon,
        UploadIcon,
        WarningIcon
    },
    Board: {
        IncubatorIcon,
        KanbanIcon
    },
    Conversation: {
        ConversationIcon,
        MessageIcon
    },
    OrganizationIcon,
    Ppm: {
        PortfolioIcon,
        ProjectGanttIcon,
        ProjectIcon
    },
    Status: {
        DoneIcon
    },
    User: {
        AddTeamIcon,
        AddUserIcon,
        RemoveTeamIcon,
        RemoveUserIcon,
        TeamIcon,
        UserIcon
    },
    Wbs: {
        WbsControlAccountIcon,
        WbsIcon,
        WorkPackageIcon
    },
    WbsComponent: {
        AddNodeChild,
        AddNodeSibling,
        AddWorkItemIcon: Add,
        AddWbsComponentChildIcon: CaretDown,
        AddWbsComponentLeftSiblingIcon: CaretLeft,
        AddWbsComponentRightSiblingIcon: CaretRight,
        AddWbsComponentParentIcon: CaretUp
    },
    WorkItem: {
        BlockedIcon,
        BugIcon,
        DoneIcon,
        IssueIcon,
        RiskIcon,
        TaskIcon,
        WorkItemIcon
    }
}

export interface ButtonIconProps {
    className?: string
    icon: JSX.Element
    shape?: ButtonShape
    size?: SizeType
    style?: React.CSSProperties
    type?: ButtonType
    onClick?: () => void
}

export const ButtonIcon: React.FC<ButtonIconProps> = (props) => {
    const { icon, className, onClick, shape, size, style, type } = props
    return (
        <div className={`${className} ${styles.button}`}>
            <Button
                onClick={onClick}
                type={type}
                style={style}
                shape={shape || 'circle'}
                icon={icon}
                size={size || 'small'}
            />
        </div>
    )
}
